import React, { Component } from 'react';
import {PieChart , Pie , Cell , Tooltip} from 'recharts'

const COLORS = ["#7BE8A3","#E3FF3E" , "#4BB7FF" , "#7F38E8" , "#FF3E69" , "#3D3D3D", "#FFFF05"]

class CustomPieChart extends Component {
    constructor(props) {
        super(props);
        this.state = {  }
    }

    static defaultProps = {
        data : [
            { "name" : "Test" , "value" : 100},
            { "name" : "Test1" , "value" : 300},
            { "name" : "Test2" , "value" : 100},
        ]
    }


    render() { 
        return (
        <PieChart width={200} height={200}>
            <Pie  data={this.props.data} dataKey="value">
            {
                this.props.data.map((entry, index) => <Cell  key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />)
            }
            </Pie>
            <Tooltip/>
        </PieChart> 
        );
    }
}
 
export default CustomPieChart;